<script>
import resources from './resources'

export default {
  name: 'professional-graduations-index',
  mixins: [resources]
}
</script>

<template lang="pug">
  page(title="Minhas Graduações", icon="")
    .col-xs-12.content
      .container-fluid
        .row
          .nav-tabs-wrapper
            ul.nav.nav-tabs.nav-340
              li.active
                a(href='#') Listagem
              li
                router-link(:to="{ name: 'professional.curriculum.graduations.create'}")
                  a(href="#") Cadastro

          .col-xs-12.white-bg.wrapper(v-if="loading")
            .row.border-bottom-light
              spinner(:show="true")
          .col-xs-12.white-bg.wrapper(v-if="!loading")
            card-add(label='Nova<br>Graduação', route='professional.curriculum.graduations.create', icon='')
            .list-item.white-bg.list-item(v-for="graduation in graduations")
              .row.border-bottom
                h4.col-xs-7(v-tooltip="graduation.label") {{ graduation.label_small }}
                .col-xs-5
                  .exclude-list(@click.prevent="doDelete(graduation)")
                    span.icon 
                  router-link(:to="{name: getRouterEdit, params: {id: graduation.id}}")
                    a(href='#')
                      .edit-list
                        span.icon 
              .list-info
                | {{ graduation.entity }}
                br
                | {{ graduation.year }}

        .pagination
          pagination(:pagination="pagination", @pagination-changed-page="setPage")
</template>



// WEBPACK FOOTER //
// src/app/professional/curriculum/graduations/index/index.vue